import React from "react";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import classNames from "classnames";


const AuthorInfoButton = React.forwardRef(
  function AuthorInfoButton({id, text, onClick, active}, ref) {
    return (
     <Button className={classNames(
       buttonStyles.button_toggle,
       buttonStyles.button_toggleInverse,
       {
       [buttonStyles['button_toggleActive']]:active
     })} onClick={()=>onClick()}>
       {safeHTML(text)}
     </Button>
    );
  });
export default AuthorInfoButton;
AuthorInfoButton.propTypes = {};

